import { ImageFromServer } from '@/components/images/ImageFromServer';
import { DeckDTO } from '@/generated';
import deck1 from '@/images/deck-1.png';
import deck2 from '@/images/deck-2.png';

export const DeckImage = (props: { deck: DeckDTO; width: number }) => {
  const { deck, width } = props;
  return deck.imageId ? (
    <ImageFromServer sx={{ width, height: width }} id={props.deck.imageId} thumbnail={true} alt={''} />
  ) : deck.deckImageNumber === 0 ? (
    <img alt="deck-img" style={{ width }} src={deck1} />
  ) : (
    <img alt="deck-img" style={{ width }} src={deck2} />
  );
};
